export enum SubscriptionType {
  REGULAR,
  COURSE,
  EVENT
}
